/* eslint-disable import/no-cycle */
import { buttonWhite, buttonOrange } from '@assets/styles/helpers/colors.styles'
import { ButtonProps } from './Button'

export const getButtonStyles = (
  color: ButtonProps['color'],
  variant: ButtonProps['variant'],
  secondaryButton: ButtonProps['secondaryButton']
) => {
  switch (color) {
    case 'primary':
      switch (variant) {
        case 'contained':
          return {
            boxShadow: 'none',
            backgroundColor: buttonWhite.contained.background,
            color: buttonWhite.contained.font,
            border: 'none',
            '&.Mui-disabled': {
              backgroundColor: buttonWhite.contained.backgroundDisabled
            },
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.contained.backgroundHover
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.contained.backgroundActive
            }
          }
        case 'outlined':
          return {
            boxShadow: 'none',
            padding: '0.125rem 0.25rem !important',
            backgroundColor: buttonWhite.outlined.background,
            color: buttonWhite.outlined.font,
            border: `2px solid ${buttonWhite.outlined.border}`,
            '&.Mui-disabled': {
              color: buttonWhite.outlined.fontDisabled,
              border: `2px solid ${buttonWhite.outlined.borderDisabled}`
            },
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.outlined.backgroundHover,
              border: `2px solid ${buttonWhite.outlined.borderHover}`
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.outlined.backgroundActive,
              border: `2px solid ${buttonWhite.outlined.borderActive}`
            }
          }
        case 'text':
          return {
            boxShadow: 'none',
            backgroundColor: buttonWhite.text.background,
            border: 'none',
            color: secondaryButton
              ? buttonWhite.text.fontHover
              : buttonWhite.text.font,
            '&.Mui-disabled': {
              color: buttonWhite.text.fontDisabled
            },
            '&:hover': {
              boxShadow: 'none',
              color: secondaryButton
                ? buttonWhite.text.fontActive
                : buttonWhite.text.fontHover
            },
            '&:active': {
              boxShadow: 'none',
              color: secondaryButton
                ? buttonWhite.text.fontDisabled
                : buttonWhite.text.fontActive
            }
          }
        default:
          return {
            boxShadow: 'none',
            backgroundColor: buttonWhite.contained.background,
            color: buttonWhite.contained.font,
            border: 'none',
            '&.Mui-disabled': {
              backgroundColor: buttonWhite.contained.backgroundDisabled
            },
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.contained.backgroundHover
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonWhite.contained.backgroundActive
            }
          }
      }
      break
    case 'secondary':
      switch (variant) {
        case 'contained':
          return {
            boxShadow: 'none',
            backgroundColor: buttonOrange.contained.background,
            color: buttonOrange.contained.font,
            border: 'none',
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.contained.backgroundHover
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.contained.backgroundActive
            },
            '&.Mui-disabled': {
              backgroundColor: buttonOrange.contained.backgroundDisabled
            }
          }
        case 'outlined':
          return {
            boxShadow: 'none',
            padding: '0.125rem 0.25rem !important',
            backgroundColor: buttonOrange.outlined.background,
            color: buttonOrange.outlined.font,
            border: `2px solid ${buttonOrange.outlined.border}`,
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.outlined.backgroundHover,
              border: `2px solid ${buttonOrange.outlined.borderHover}`
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.outlined.backgroundActive,
              border: `2px solid ${buttonOrange.outlined.borderActive}`
            },
            '&.Mui-disabled': {
              color: buttonOrange.outlined.fontDisabled,
              border: `2px solid ${buttonOrange.outlined.borderDisabled}`
            }
          }
        case 'text':
          return {
            boxShadow: 'none',
            backgroundColor: buttonOrange.text.background,
            border: 'none',
            color: secondaryButton
              ? buttonOrange.text.fontHover
              : buttonOrange.text.font,
            '&:hover': {
              boxShadow: 'none',
              color: secondaryButton
                ? buttonOrange.text.fontActive
                : buttonOrange.text.fontHover
            },
            '&:active': {
              boxShadow: 'none',
              color: secondaryButton
                ? buttonOrange.text.fontDisabled
                : buttonOrange.text.fontActive
            },
            '&.Mui-disabled': {
              color: buttonOrange.text.fontDisabled
            }
          }
        default:
          return {
            boxShadow: 'none',
            backgroundColor: buttonOrange.contained.background,
            color: buttonOrange.contained.font,
            border: 'none',
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.contained.backgroundHover
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: buttonOrange.contained.backgroundActive
            },
            '&.Mui-disabled': {
              backgroundColor: buttonOrange.contained.backgroundDisabled
            }
          }
      }

    default:
      return {
        boxShadow: 'none',
        backgroundColor: buttonWhite.contained.background,
        color: buttonWhite.contained.font,
        border: 'none',
        '&.Mui-disabled': {
          backgroundColor: buttonWhite.contained.backgroundDisabled
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: buttonWhite.contained.backgroundHover
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: buttonWhite.contained.backgroundActive
        }
      }
  }
}
